export default __webpack_public_path__ + "0ed51ab45d97124f677e2d24cfd642a9.svg";